/**
 * Subscription tier picker — card selection + direct add-to-cart for Overraskelse.
 */
(function () {
  'use strict';

  var tiersRoot = document.getElementById('sc-pricing');
  if (!tiersRoot) return;

  var barNameEl = document.getElementById('sc-mship-bar-name');
  var barPriceEl = document.getElementById('sc-mship-bar-price');
  var barCta = document.getElementById('sc-mship-bar-cta');
  var mobileBar = document.getElementById('sc-mship-bar');

  function isDirectCart(card) {
    return card && card.getAttribute('data-tier-direct-cart') === 'true';
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('sc-tier-cta--loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function getCheckoutUrl() {
    if (window.ScentyCampaignDiscount && typeof window.ScentyCampaignDiscount.getCheckoutUrl === 'function') {
      return window.ScentyCampaignDiscount.getCheckoutUrl('/checkout');
    }
    return '/checkout';
  }

  function formatBarPrice(card) {
    if (!card) return '';
    var amount = parseInt(card.getAttribute('data-tier-price-amount'), 10);
    var period = card.getAttribute('data-tier-period') || '/md';
    if (
      window.ScentyCampaignDiscount &&
      amount &&
      typeof window.ScentyCampaignDiscount.getDiscountedDisplayForAmount === 'function'
    ) {
      var display = window.ScentyCampaignDiscount.getDiscountedDisplayForAmount(amount, period);
      if (display && display.html && barPriceEl) {
        barPriceEl.classList.add('sc-mship-bar__price--campaign');
        barPriceEl.innerHTML = display.html;
        return display.text;
      }
    }
    if (barPriceEl) {
      barPriceEl.classList.remove('sc-mship-bar__price--campaign');
      barPriceEl.textContent = card.getAttribute('data-tier-price') || '';
    }
    return card.getAttribute('data-tier-price') || '';
  }

  function updateMobileBar(card) {
    if (!card) return;

    var name = card.getAttribute('data-tier-name') || '';
    var price = formatBarPrice(card);
    var url = card.getAttribute('data-tier-url') || '#';
    var directCart = isDirectCart(card);

    if (barNameEl) barNameEl.textContent = name;
    if (!barPriceEl || !barPriceEl.classList.contains('sc-mship-bar__price--campaign')) {
      if (barPriceEl) barPriceEl.textContent = price || card.getAttribute('data-tier-price') || '';
    }
    if (barCta) {
      barCta.setAttribute('href', url);
      barCta.setAttribute('data-tier-direct-cart', directCart ? 'true' : 'false');
    }
  }

  function selectTier(card, shouldScroll) {
    if (!card) return;

    tiersRoot.querySelectorAll('.sc-tier--selected').forEach(function (el) {
      el.classList.remove('sc-tier--selected');
      el.setAttribute('aria-checked', 'false');
    });

    card.classList.add('sc-tier--selected');
    card.setAttribute('aria-checked', 'true');
    updateMobileBar(card);
    document.dispatchEvent(new CustomEvent('scenty:tier:selected', { detail: { card: card } }));

    if (shouldScroll && window.matchMedia('(max-width: 900px)').matches) {
      requestAnimationFrame(function () {
        card.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
      });
    }
  }

  function addTierToCart(card) {
    var variantId = card.getAttribute('data-tier-variant-id');
    if (!variantId) {
      return Promise.reject(new Error('Produktet kunne ikke findes. Prøv igen.'));
    }

    var item = {
      id: parseInt(variantId, 10),
      quantity: 1
    };

    var sellingPlan = card.getAttribute('data-tier-selling-plan');
    if (sellingPlan) {
      item.selling_plan = parseInt(sellingPlan, 10);
    }

    var cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (cartUrl.indexOf('.js') === -1) {
      cartUrl += '.js';
    }

    return fetch(cartUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Kunne ikke lægge i kurv.');
        }
        return data;
      });
    });
  }

  function handleDirectCart(card, btn) {
    if (!isDirectCart(card)) return false;

    setLoading(btn, true);

    addTierToCart(card)
      .then(function () {
        window.location.href = getCheckoutUrl();
      })
      .catch(function (err) {
        setLoading(btn, false);
        window.alert(err && err.message ? err.message : 'Kunne ikke lægge i kurv. Prøv igen.');
      });

    return true;
  }

  function getSelectedTier() {
    return (
      tiersRoot.querySelector('.sc-tier--selected') ||
      tiersRoot.querySelector('.sc-tier--selectable[data-tier-recommended="true"]') ||
      tiersRoot.querySelector('.sc-tier--selectable')
    );
  }

  function proceedWithTier(card, btn) {
    if (!card) return;

    if (isDirectCart(card)) {
      handleDirectCart(card, btn || card.querySelector('.sc-tier__cta'));
      return;
    }

    var url = card.getAttribute('data-tier-url');
    if (url && url !== '#') {
      window.location.href = url;
    }
  }

  tiersRoot.addEventListener('click', function (e) {
    var cta = e.target.closest('.sc-tier__cta');
    if (cta) {
      var ctaCard = cta.closest('.sc-tier--selectable');
      if (ctaCard && isDirectCart(ctaCard)) {
        e.preventDefault();
        handleDirectCart(ctaCard, cta);
      }
      return;
    }

    if (e.target.closest('.sc-tier__features-more')) return;

    var card = e.target.closest('.sc-tier--selectable');
    if (!card) return;

    if (card.classList.contains('sc-tier--selected')) {
      e.preventDefault();
      proceedWithTier(card);
      return;
    }

    selectTier(card, true);
  });

  tiersRoot.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var card = e.target.closest('.sc-tier--selectable');
    if (!card) return;

    e.preventDefault();

    if (card.classList.contains('sc-tier--selected')) {
      proceedWithTier(card);
      return;
    }

    selectTier(card, true);
  });

  var preselected = getSelectedTier();
  if (preselected) {
    selectTier(preselected, false);
  }

  document.addEventListener('scenty:campaign:applied', function () {
    var selected = getSelectedTier();
    if (selected) selectTier(selected, false);
  });

  if (barCta) {
    barCta.addEventListener('click', function (e) {
      if (barCta.getAttribute('data-tier-direct-cart') !== 'true') return;

      var selected = getSelectedTier();
      if (!selected || !isDirectCart(selected)) return;

      e.preventDefault();
      handleDirectCart(selected, barCta);
    });
  }

  if (mobileBar) {
    document.documentElement.style.setProperty(
      '--sc-sticky-offset',
      mobileBar.offsetHeight + 'px'
    );
  }
})();
